import dynamic from 'next/dynamic'
import { Navigation } from 'components/Navigation'
import { StickyFooter } from 'components/StickyFooter'
import { SkillsYoullLearnSection } from '../components/variant_2/sections'
import { Hero } from '../components/variant_2/sections/Hero'

const BelowTheFold = dynamic(
  () =>
    import('../components/variant_2/BelowTheFold').then((m) => m.BelowTheFold),
  {
    ssr: false,
  },
)

export const Variant2PageContent = () => (
  <div>
    <Navigation /> {/* pen-5015_v1 experiment */}
    <Hero />
    <SkillsYoullLearnSection />
    <BelowTheFold />
    <StickyFooter />
  </div>
)
